import gifIcon from 'assets/image/icons/svg/gif-icon.svg'
import { useRef, useState } from 'react'

import { Label } from '../../const'
import { GifPopover } from './GifPopover'
import { useUploadExternalMedia } from './hooks'

export function GifButton() {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLButtonElement | null>(null)
  const upload = useUploadExternalMedia()

  return (
    <>
      <button
        aria-label={Label.Gif}
        className='li-⚪ gif-anchor'
        onClick={() => setOpen(v => !v)}
        ref={anchorRef}
        title={Label.Gif}
        type='button'
      >
        <img alt='' aria-hidden height={20} src={gifIcon} width={20} />
      </button>
      {open && (
        <GifPopover
          anchor={anchorRef.current}
          onClose={() => setOpen(false)}
          onSelect={gif => {
            upload(gif.url)
            setOpen(false)
          }}
        />
      )}
    </>
  )
}


